import { jsx as l } from "react/jsx-runtime";
const o = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M19 10H5v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM3 10V5c0-.824.332-1.57.869-2.112l.01-.01.01-.009A3 3 0 0 1 6 2h12a3 3 0 0 1 2.121.879l.01.01A3 3 0 0 1 21 5v14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm5 2.5a1 1 0 1 0 0 2h3.882a1 1 0 1 0 0-2zm3.5 3a1 1 0 1 0 0 2H16a1 1 0 1 0 0-2z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
